module.exports = __webpack_public_path__ + "media/10.4caf2d37.mp3";